var map = {
	"./dassLogoRed.svg": 8973,
	"./files/file.png": 6238,
	"./files/icons8-devolver-compra-fila.png": 5968,
	"./files/icons8-devolver-compra-newbalance.png": 2368,
	"./files/icons8-devolver-compra-umbro.png": 7057,
	"./files/icons8-notificação-40.png": 6052,
	"./fonts/ItalianPlateNoTwo-Bd.otf": 7861,
	"./fonts/ItalianPlateNoTwo-Md.otf": 8848,
	"./fonts/proximanova-regular.otf": 3386,
	"./fonts/proximanova-semibold.otf": 3911,
	"./icons8-notificação-black-24.png": 4176,
	"./icons8-notificação-white-30.png": 6993,
	"./jadlog-icon.png": 4615,
	"./logo.svg": 3935,
	"./nfeIcon.png": 7372,
	"./pac-correios-icon.png": 9369,
	"./theme/fila/logo.png": 156,
	"./theme/new_balance/logo.png": 1797,
	"./theme/new_balance/logoMobile.png": 575,
	"./theme/umbro/logo.png": 3663
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 290;